module.exports = __webpack_public_path__ + "zmenseni-prsou_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_6_before.jpg
// module id = 1288
// module chunks = 0